(() => {
  const collection = document.querySelector('.crealux-collection');
  if (!collection) return;

  const filterButton = collection.querySelector('[data-collection-filter-toggle]');
  const filterPanel = collection.querySelector('[data-collection-filter-panel]');
  const closeButton = collection.querySelector('[data-collection-filter-close]');
  const setFiltersOpen = (open) => {
    if (!filterPanel || !filterButton) return;
    filterPanel.hidden = !open;
    filterButton.setAttribute('aria-expanded', String(open));
    if (open) closeButton?.focus();
    else filterButton.focus();
  };
  filterButton?.addEventListener('click', () => setFiltersOpen(filterPanel.hidden));
  closeButton?.addEventListener('click', () => setFiltersOpen(false));
  collection.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && filterPanel && !filterPanel.hidden) setFiltersOpen(false);
  });

  collection.querySelector('[data-collection-sort]')?.addEventListener('change', (event) => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', event.currentTarget.value);
    url.searchParams.delete('page');
    window.location.assign(url.toString());
  });

  collection.querySelectorAll('[data-card-gallery]').forEach((gallery) => {
    const images = [...gallery.querySelectorAll('.crealux-card__image')];
    const dots = [...gallery.querySelectorAll('[data-card-image]')];
    if (images.length < 2 || dots.length < 2) return;
    dots.forEach((dot) => dot.addEventListener('click', () => {
      const active = Number(dot.dataset.cardImage);
      images.forEach((image, index) => image.classList.toggle('is-current', index === active));
      dots.forEach((button, index) => {
        button.classList.toggle('is-current', index === active);
        button.setAttribute('aria-pressed', String(index === active));
      });
    }));
  });
})();
